<template>
  <div>
      <div class="md-layout-item md-size-100" v-if="!load">
        <md-progress-bar md-mode="indeterminate"></md-progress-bar>
      </div>
    <form novalidate class="md-layout" @submit.prevent="validateChain" v-if="load">
      <div class="md-layout-item md-size-100" >
        <div class="md-title">Chain Info</div>

        <img class="chain-logo" :src=logoPreview v-if="logoPreview !== null">
        <!-- <md-field>
          <label>Logo</label>
          <md-file v-model="form.logoUrl" accept="image/*" @md-change="setImage($event)" :disabled="sending" />
        </md-field> -->
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <field fieldName="name" ref="name" :validations="{required: true}" :fieldValue=form.name fieldLabel="Name"
              fieldId="name" :sending="sending" @setfield="setFormField($event)" v-can-edit/>
          </div>
          <div class="md-layout-item md-small-size-100">
            <field fieldName="address" ref="address" :fieldValue=form.address fieldLabel="Address" fieldId="address"
              :sending="sending" @setfield="setFormField($event)" v-can-edit/>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <field-select fieldName="languageId" ref="language" :fieldValue="form.languageId" fieldLabel="Chain Language"
              fieldId="language" :values="languages" valueId="id" valueLabel="name" :sending="sending" @setfield="setFormField($event)" v-can-edit/>
          </div>
          <div class="md-layout-item md-small-size-100">
            <field-select fieldName="timezone" ref="timezone" :fieldValue="form.timeZoneId" fieldLabel="Timezone" fieldId="timezone"
              :values="timezones" valueId="timeZoneId" valueLabel="name" :sending="sending" @setfield="setFormField($event)" v-can-edit/>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <field-select fieldName="measurementSystem" ref="measurementSystem" :fieldValue="form.measurementSystem"
              fieldLabel="Measurement system" fieldId="measurementSystem" :values="measurementSystems" valueId="measurement"
              valueLabel="name" :sending="sending" @setfield="setFormField($event)" v-can-edit/>
          </div>
          <div class="md-layout-item md-small-size-100">
            <field-select fieldName="country" ref="country" :fieldValue="form.countryId" fieldLabel="Country" fieldId="country"
              :values="countries" valueId="countryId" valueLabel="name" :sending="sending" @setfield="setFormField($event)" v-can-edit/>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <field fieldName="zipCode" ref="postcode" :fieldValue=form.zipCode fieldLabel="Zip code" fieldId="zipCode"
              :sending="sending" @setfield="setFormField($event)" v-can-edit/>
          </div>
          <div class="md-layout-item md-small-size-100">
            <field fieldName="stateProvince" ref="childComponent" :fieldValue=form.stateProvince fieldLabel="Province"
              fieldId="stateProvince" :sending="sending" @setfield="setFormField($event)" v-can-edit/>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <field fieldName="phoneNumber" ref="phoneNumber" :fieldValue=form.phoneNumber fieldLabel="Phone number"
              fieldId="phone-number" :sending="sending" @setfield="setFormField($event)" v-can-edit/>
          </div>
          <div class="md-layout-item md-small-size-100">
            <field fieldName="email" ref="email" :validations="{email: true}" :fieldValue=form.email fieldLabel="Email"
              fieldId="email" :sending="sending" @setfield="setFormField($event)" v-can-edit/>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <field fieldName="website" ref="website" :fieldValue=form.website fieldLabel="Website" fieldId="website"
              :sending="sending" @setfield="setFormField($event)" v-can-edit/>
          </div>
        </div>
        <md-progress-bar md-mode="indeterminate" v-if="sending" />
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100 right-align">
            <md-button type="submit" class="md-raised md-primary" :disabled="sending">Save</md-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import NavigationLayout from '@/components/layouts/navigation'
import RepositoryService from '@/services/repositoryService'
import Utils from '@/utils/utils'
import Field from '@/components/elements/field'
import FieldSelect from '@/components/elements/select'
import NotificationService from '@/services/notificationService'

export default {
  name: 'ChainInfo',
  data: () => ({
    selectedChain: RepositoryService.session.selectedFacility,
    form: {},
    languages: null,
    timezones: null,
    measurementSystems: null,
    countries: null,
    logoPreview: null,
    sending: false,
    load: false
  }),
  components: {
    NavigationLayout,
    Field,
    FieldSelect
  },
  props: ['parentref'],
  methods: {
    setImage (file) {
      if (file && file[0]) {
        var reader = new FileReader()
        var self = this
        reader.onloadend = function () {
          self.logoPreview = reader.result
        }
        reader.readAsDataURL(file[0])
      }
    },
    async validateChain () {
      var results = []
      for (var property in this.$refs) {
        if (this.$refs.hasOwnProperty(property) && this.$refs[property].validateField) {
          results.push(await this.$refs[property].validateField())
        }
      }
      var canSave = results.every((value) => {
        return value
      })
      if (canSave && this.form.companyName) {
        this.sending = true
        await NotificationService.manageNotification(this.parentref, await RepositoryService.updateChain(this.form),
          (data) => {
            if (data.result === 'Success') {
              RepositoryService.session.setselectedFacility(this.form)
            } else {
              this.parentref.$refs.navigationlayout.setNotification(`Something goes wrong`)
            }
          })
        this.sending = false
      }
    },
    setFormField (fieldObj) {
      this.form[fieldObj.fieldName] = fieldObj.fieldValue
    }
  },
  created: async function () {
    this.form = this.selectedChain
    this.logoPreview = this.selectedChain.logoUrl
    await NotificationService.manageNotification(this.parentref, await RepositoryService.getLists(),
      (data) => {
        this.countries = data.countries.sort(Utils.orderArrayObjectByFieldNumberAsc('countryId'))
        this.timezones = data.timezones.sort(Utils.orderArrayObjectByFieldNumberAsc('baseUtcOffset'))
        this.languages = data.languages.sort(Utils.orderArrayObjectByFieldNumberAsc('id'))
        this.measurementSystems = data.measurementSystems.sort(Utils.orderArrayObjectByFieldNumberAsc('id'))
      })
    this.load = true
  }
}

</script>

<style lang="scss" scoped>
  .chain-logo {
    max-width: 200px;
    max-height: 200px;
    vertical-align: middle;
    margin-right: 10px;
  }

  .right-align {
    text-align: right;
  }

</style>
